import { TabListProperty } from '../enums';

const TabListProps = {
  props: {
    [TabListProperty.Tabs]: {
      default: () => [],
      type: Array,
    },
    [TabListProperty.ActiveIndex]: {
      default: 0,
      type: Number,
    },
  },
};

export default TabListProps;
